import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=8ca5696e"
import script from "./PrivacyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=8ca5696e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports